import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Pencil } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";

export const NotasAngariacao = ({ p, onDone }) => {
  const [edit, setEdit] = useState(false);
  const [text, setText] = useState(p.angariacao_notes || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/processes/${p.id}`, { angariacao_notes: text.trim() });
      toast.success("Notas guardadas"); setEdit(false); onDone?.();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="py-3 border-t border-slate-100" data-testid="ang-notes">
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-sm text-slate-500">Notas da angariação</span>
        {!edit && onDone && <button onClick={() => { setText(p.angariacao_notes || ""); setEdit(true); }} className="text-slate-400 hover:text-slate-700" aria-label="Editar notas" data-testid="ang-notes-edit"><Pencil size={13} /></button>}
      </div>
      {edit ? (
        <div className="mt-1.5 space-y-2">
          <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} placeholder="Garagem, remodelado, estudo de mercado por fazer…" data-testid="ang-notes-input" />
          <div className="flex gap-2">
            <button onClick={save} disabled={busy} className="text-xs px-3 py-1.5 rounded-lg bg-ec-green text-white hover:bg-ec-greenDark disabled:opacity-60" data-testid="ang-notes-save">Guardar</button>
            <button onClick={() => setEdit(false)} className="text-xs px-3 py-1.5 rounded-lg border border-slate-200 hover:bg-slate-50" data-testid="ang-notes-cancel">Cancelar</button>
          </div>
        </div>
      ) : (
        <div className={`text-[15px] mt-0.5 whitespace-pre-line ${p.angariacao_notes ? "navy-text" : "text-slate-400"}`} data-testid="ang-notes-text">{p.angariacao_notes || "Sem notas"}</div>
      )}
    </div>
  );
};
